import { forwardRef } from "react";
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";
import { PieceLayoutMode } from "features/builder/pieceList";

export const AddMapCard = forwardRef<
  HTMLDivElement,
  { layoutMode: PieceLayoutMode; onClick: () => void }
>(({ layoutMode, onClick }, ref) => {
  const play = usePlaySound();

  const handleClick = () => {
    play();
    btnDelay(() => onClick());
  };

  if (layoutMode === PieceLayoutMode.LIST) {
    return (
      <div
        ref={ref}
        onClick={handleClick}
        aria-label={I18n.t("MSG_BUILDER_NEW_MAP_BTN")}
        className="flex-row-el flex-center box-border w-full gap-2 py-6 rounded-xl border-2 border-dashed border-green-60 bg-white/40 pointer-events-auto cursor-pointer"
      >
        <span className="material-symbols-outlined text-green-100 type-md">add</span>
        <p className="type-text type-body text-green-100">{I18n.t("MSG_BUILDER_NEW_MAP_BTN")}</p>
      </div>
    );
  }

  // GRID_2 は MapCard の compact（aspect-square）、GRID_1 は aspect-[4/3] に合わせる
  const compact = layoutMode === PieceLayoutMode.GRID_2;

  return (
    <div
      ref={ref}
      onClick={handleClick}
      aria-label={I18n.t("MSG_BUILDER_NEW_MAP_BTN")}
      className={`flex-col-el flex-center box-border relative w-full ${
        compact ? "aspect-square" : "aspect-[4/3]"
      } gap-2 rounded-2xl border-2 border-dashed border-green-60 bg-white/40 pointer-events-auto cursor-pointer`}
    >
      <span className="material-symbols-outlined text-green-100 type-hero">add</span>
      <p className="type-text type-body text-green-100">{I18n.t("MSG_BUILDER_NEW_MAP_BTN")}</p>
    </div>
  );
});
